import useUserRole from 'src/hooks/useUserRole'
import { useVenueCustomRoles } from 'src/hooks/useIsBlocked'
import { getStockRoleCapabilities } from 'src/utils/permissions'

const useStockRoleCapabilities = roleOverride => {
  const roleFromHook = useUserRole()
  const customRoles = useVenueCustomRoles()
  const role = roleOverride ?? roleFromHook
  return getStockRoleCapabilities(role, customRoles)
}

export default useStockRoleCapabilities
